import { FlexRow } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import { useLocale } from "designSystem/locale";
import { useExternalAPIWizardStore, OAuth2AuthType } from "./ExternalAPIWizardStore";
import { OAuth2TypeSetupForm } from "./OAuth2TypeSetupForm";
import { APIKeyTypeSetupForm } from "./APIKeyTypeSetupForm";

export const ExternalAPIConnectorPage = observer(() => {
	const locale = useLocale();
	const store = useExternalAPIWizardStore();
	const { authType, authTypeOptions, setAuthTypeChecked } = store || {};

	return (
		<>
			<FlexRow paddingBottom={4}>
				<RadioGroup
					name={locale.resource("AuthType")}
					onChange={setAuthTypeChecked}
					options={authTypeOptions}
					value={authType}
				/>
			</FlexRow>
			<FlexRow centerContent>
				{authType === OAuth2AuthType ? (
					<OAuth2TypeSetupForm />
				) : (
					<APIKeyTypeSetupForm />
				)}
						
			</FlexRow>
		</>
	);
});

export default ExternalAPIConnectorPage;